import axios from 'axios'
import Servers from "../../server"
export default{
    state: {
      fracObj: [],
      fracEdit: false,
      fracCapabilities: null,
    },
    mutations: {
      setFrac(state, obj){
        state.fracObj = obj;
      },
      setFracEdit(state, obj){
        state.fracEdit = obj;
      },
      setFracCapabilities(state, obj){
        state.fracCapabilities = obj;
      }
    },
    getters: {
      getFrac(state){
        return state.fracObj
      },
      getFracEdit(state){
        return state.fracEdit
      },
      getFracCapabilities(state){
        return state.fracCapabilities
      },
      hasFacialRecognition(state){
        return state.fracCapabilities?.features?.facialRecognitionResidents || false
      }
    },
    actions: {
      async getFracInfo(context, uuid){

        let response = await axios.get(Servers.serverApi+"api/fracs/"+uuid, {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        });

        let objt = response.data;

        context.commit('setFrac', objt)
        context.commit('setFracEdit', true)
        return;

      },
      async fetchFracCapabilities(context){
        try {
          let response = await axios.get(Servers.serverApi + "api/fracs/fracCapabilities", {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          });
          context.commit('setFracCapabilities', response.data)
          return response.data
        } catch (error) {
          console.error("Error fetching frac capabilities:", error)
          context.commit('setFracCapabilities', null)
          return null
        }
      }
    }
}